<div class="row d-flex justify-content-center m-5">
    <div class="col-auto">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden"></span>
        </div>
    </div>
    <div class="col-auto">Loading, Please Wait...</div>
</div>
